package ru.villawonka.app

import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.window.CanvasBasedWindow
import kotlinx.browser.document
import org.jetbrains.skiko.wasm.onWasmReady

@OptIn(ExperimentalComposeUiApi::class)
fun main() {
    onWasmReady {
        if (BuildConfig.isDebug) {
            loadEruda {
                CanvasBasedWindow { App() }
            }
        } else {
            CanvasBasedWindow { App() }
        }
    }
}

fun loadEruda(onLoaded: () -> Unit) {
    val script = document.createElement("script")
    script.asDynamic().src = "https://cdn.jsdelivr.net/npm/eruda"
    script.addEventListener("load", {
        js("eruda.init()")
        onLoaded()
    })
    document.head?.appendChild(script)
}